module.exports = __webpack_public_path__ + "spa-static/img/tg.ed85e9f2.svg";